import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";
import {
    dateClassRule,
    dateFormatter,
    dateValueGetter,
    dateFilterParams,
    dateComparator,
} from "@icarius-table/date";
import { numberComparatorMax2, numberFilterParams } from "@icarius-table/number";

export default () => [
    {
        pages: [paths.consentPublication],
        config: {
            headerName: getLocalizedString("code"),
            field: "Código de empleado",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.consentPublication],
        config:
        {
            headerName: getLocalizedString("nameAndSurname"),
            field: "Apellidos y nombres",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.consentPublication],
        config:
        {
            field: "Tipo de consentimiento string",
            headerName: getLocalizedString("consentType"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.consentPublication],
        config: {
            field: "Fecha de publicación",
            headerName: getLocalizedString("publicationDate"),
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.consentPublication],
        config: {
            field: "Días transcurridos sin recepcionar",
            headerName: getLocalizedString("daysElapsedWithoutReception"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.consentPublication],
        config:
        {
            field: "Consentimiento recepcionado",
            headerName: getLocalizedString("consentReceived"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.consentPublication],
        config: {
            field: "Fecha de recepción",
            headerName: getLocalizedString("receptionDate"),
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.consentPublication],
        config:
        {
            field: "Referencia de publicación",
            headerName: getLocalizedString("publicationReference"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.consentPublication],
        config: {
            headerName: getLocalizedString("incomeDate"),
            field: "Fecha de contratación",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.consentPublication],
        config: {
            headerName: getLocalizedString("email"),
            field: "Email",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.consentPublication],
        config: {
            headerName: getLocalizedString("cellphone"),
            field: "Celular",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.consentPublication],
        config: {
            headerName: getLocalizedString("functionaryTypePlant"),
            field: "Personal de planta",
            filter: "agSetColumnFilter",
        }
    },
    {

        pages: [paths.consentPublication],
        config: {
            headerName: getLocalizedString("position"),
            field: "Cargo",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.consentPublication],
        config: {
            headerName: getLocalizedString("fType"),
            field: "Tipo de funcionario",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.consentPublication],
        config: {
            headerName: getLocalizedString("jobLocation"),
            field: "Lugar de trabajo",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.consentPublication],
        config: {
            headerName: getLocalizedString("filterObra o Faena"),
            field: "Obra o Faena",
            filter: "agSetColumnFilter",
        }
    },
]